import { api } from '@/lib/api'
import type { ContractParty, PartyRole } from './types'

export async function listParties(contractId: number) {
  const r = await api.get<ContractParty[]>(`/api/contracts/${contractId}/parties`)
  return r.data
}

export async function addParty(contractId: number, customerId: number, roleCode: string) {
  const r = await api.post<ContractParty>(
    `/api/contracts/${contractId}/parties`,
    { customerId, roleCode },
  )
  return r.data
}

export async function deleteParty(partyId: number) {
  await api.delete(`/api/contract-parties/${partyId}`)
}

export async function listPartyRoles() {
  const r = await api.get<PartyRole[]>('/api/contract-party-roles')
  return r.data
}
